// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"ef67e129","393":"6cfd9a8d","677":"2fb33c70"}[chunkId] + ".chunk.js";
};